import { TableConstructorData, TableDataAdaptee } from 'src/app/interfaces/tables.interfaces';
import { TableConstructorDataFactory } from './table-constructor-data.factory';

export class TableConstructorDataAdapter extends TableConstructorDataFactory {
  public constructor(private adaptee: TableDataAdaptee) {
    super();
  }

  public override createTableConstructorData(): TableConstructorData {
    return super.createTableConstructorData(
      { thead: this.adaptee.getTableHeadData(), tbody: this.adaptee.createTableBody() },
      this.adaptee.getCellAttributes(),
      this.adaptee.getCellStyles(),
    );
  }
}
